import { useState } from 'react';
import { useStripe, useElements, PaymentElement } from '@stripe/react-stripe-js';
import { Button } from 'reactstrap';
import { describePaymentIntent, StripeOutcome } from '../../../helpers/stripeStatus';

type EnrollPaymentFormProps = {
  amount: number;
  onSettled: (outcome: StripeOutcome) => void;
  onCancel: () => void;
};

const EnrollPaymentForm = ({ amount, onSettled, onCancel }: EnrollPaymentFormProps) => {
  const stripe = useStripe();
  const elements = useElements();

  const [errorMessage, setErrorMessage] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (event: any) => {
    event.preventDefault();
    if (!stripe || !elements || submitting) {
      return;
    }

    setSubmitting(true);
    setErrorMessage('');

    const { error, paymentIntent } = await stripe.confirmPayment({
      elements,
      redirect: 'if_required',
    });

    if (error) {
      setErrorMessage(error.message || 'We could not process this card.');
      setSubmitting(false);
      return;
    }

    const outcome = describePaymentIntent(paymentIntent?.status);
    if (!outcome.settled) {
      setErrorMessage(outcome.message);
      setSubmitting(false);
      return;
    }

    setSubmitting(false);
    onSettled(outcome);
  };

  return (
    <form onSubmit={handleSubmit}>
      <PaymentElement />
      {errorMessage ? (
        <div className="text-danger mt-3" role="alert">
          {errorMessage}
        </div>
      ) : null}
      <div className="d-flex justify-content-end mt-4">
        <Button color="danger" type="button" onClick={onCancel} disabled={submitting}>
          Cancel
        </Button>
        <Button color="primary" type="submit" disabled={!stripe || submitting}>
          {submitting ? 'Processing...' : `Agree and pay $${Number(amount || 0).toFixed(2)}`}
        </Button>
      </div>
    </form>
  );
};

export default EnrollPaymentForm;
